import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Serious Allergy' },
    { value: 2, label: 'Non-Serious Allergy' },
    { value: 3, label: 'Serious Medical Condition' },
    { value: 4, label: 'Non-Serious Medical Condition' },
    { value: 5, label: 'Short-Term Medical Condition' },
  ],
});
